// extracted by mini-css-extract-plugin
export default {"container":"DiagnosisExternal_container__bOenU","wrapper":"DiagnosisExternal_wrapper__z1FTM","iframe":"DiagnosisExternal_iframe__hJ3CM"};